import { useState, useCallback } from "react";
import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react";
import { BlockEditModal } from "../BlockEditModal";
import styles from "../blocks/blocks.module.scss";

export function ChapterBreakNodeView({ node, updateAttributes, selected, deleteNode }: NodeViewProps) {
  const label = (node.attrs.label as string) || "";

  const [isOpen, setIsOpen] = useState(false);
  const [draftLabel, setDraftLabel] = useState(label);

  const handleOpen = useCallback(() => {
    setDraftLabel(label);
    setIsOpen(true);
  }, [label]);

  const handleSave = useCallback(() => {
    updateAttributes({ label: draftLabel });
    setIsOpen(false);
  }, [draftLabel, updateAttributes]);

  return (
    <NodeViewWrapper data-type="chapter-break-block" data-block-id={node.attrs.blockId} className={selected ? "ProseMirror-selectednode" : ""}>
      <div className={styles.chapterBreakBlock} onDoubleClick={handleOpen} title="Double-click to edit label">
        <div className={styles.chapterBreakLine}>
          <span className={styles.chapterBreakLabel}>{label || "Chapter Break"}</span>
        </div>
      </div>

      <BlockEditModal
        sourceNode={node}
        title="Edit Chapter Break"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onSave={handleSave}
        onDelete={() => { setIsOpen(false); deleteNode(); }}
        width={400}
      >
        <div>
          <label style={{ display: "block", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Label (optional)</label>
          <input
            type="text"
            value={draftLabel}
            onChange={(e) => setDraftLabel(e.target.value)}
            placeholder="e.g., Chapter 2"
            autoFocus
            style={{ width: "100%", padding: "8px 12px", fontSize: 13, border: "1px solid var(--lilia-border, #ddd)", borderRadius: 4 }}
          />
        </div>
      </BlockEditModal>
    </NodeViewWrapper>
  );
}
